import { Store } from '@/store';
import sav from '@/sav/sav';

/**
 * Inquiry Definition Functions
 */
export default class InquiryDefinitionFunctions {
  //---------------------------------------------------
  //
  //  API / Public Methods
  //
  //---------------------------------------------------
  static async getBranches() {
    const branch = Store.branch;
    const value = branch.uuid;
    const options = [{ value, label: branch.name }];
    return { options, value };
  }

  static async getPsychologists() {
    const permission = Store.permissions;
    const users = await sav.api.get('/users/psychologists');
    let options = users.map(user => ({ value: user.uuid, label: user.name }));
    options.unshift({ value: null, label: 'Keine' });
    if (!permission.inquiryCanCreateFull && permission.inquiryCanCreateStub) {
      options = options.filter(u => u.value !== Store.uuid);
    }
    return { options };
  }

  static async getResidencyYears() {
    const options = [
      { value: 'Geburt', label: 'Geburt' },
    ];
    const date = new Date().getFullYear();
    for (let i = 0; i < 26; i += 1) {
      const year = date - i;
      options.push({
        value: year,
        label: `${year}`,
      });
    }
    return { options };
  }

  static async getCurrentDate() {
    const date = new Date();
    return date.toISOString().split('T')[0];
  }

  static async getUserUuid() {
    return Store.uuid;
  }
}
